<template>
  <div class="Archives__area">
    <div
      v-for="(scheduleClassOfDate,date) of listClasses"
      :id="`date-${date}`"
      :key="date"
      class="Archives__box"
    >
      <div class="Archives__box_left">
        <div class="Archives__box_date">
          {{ showDate(date) }}
        </div>
        <div class="Archives__box_line" />
        <div class="Archives__box_line_hide" />
      </div>
      <div class="Archives__box_right Card__archives_area">
        <div
          v-for="(item,key) of scheduleClassOfDate"
          :key="key"
          class="Archives_class_box"
          @click="openModalSchedule(item.id)"
        >
          <div
            class="Card__box Card__box--sm"
            :style="parseCssVars(item.master_program_category)"
          >
            <div class="Card__box_label Card__box_label_secondary">
              <div class="Label Label__time Card__box_time_label_secondary">
                {{ item.time }} 分
              </div>
              <span class="Card__box_label_time">
                <img
                  :src="item.master_program_category.c_icon_url"
                  alt="icon"
                  class="Card__box_label_icon"
                >
                {{ item.learning_time }}
              </span>
              <span class="Card__box_label_class">
                {{ item.title }}
              </span>
              <span class="Card__box_label_name">
                <img
                  :src="showAvatar(item.master_instructor)"
                  alt="avatar"
                  class="Card__box_label_avatar"
                >
                {{ item.master_instructor.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import melontvService from '@/services/melontvService'
import moment from 'moment'
import { convertAvatar } from '@/helpers'
import { parseCssVars } from '@/helpers/programCategory'

export default {
  name: 'MelonTVScheduleList',
  data() {
    return {
      isModalMelonTV: false,
      listClasses: {},
      melontvDetail: {}
    }
  },
  async mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getListClasses()
    },
    showModal(id) {
      this.isModalMelonTV = true
      melontvService.show(id).then((detail) => {
        this.melontvDetail = detail.data
      }).catch(error => {
        console.log(error)
      })
    },
    showTime(time) {
      return time + ' 分'
    },
    handleListClasses(list) {
      const listDate = {}
      list.forEach(function(item) {
        if (item.date !== null) {
          const date = moment(item.date).format('YYYY-MM-DD')
          if (typeof listDate[date] !== 'undefined') {
            listDate[date].push(item)
          } else {
            listDate[date] = [item]
          }
        }
      })
      this.listClasses = listDate
    },
    async getListClasses() {
      this.$store.dispatch('loading/updateLoading', true)
      const response = await melontvService.list()
      this.handleListClasses(response.data)
      this.$store.dispatch('loading/updateLoading', false)
    },
    showDate(date) {
      return moment(date).locale('ja').format('MMMDo(ddd)')
    },
    openModalSchedule(scheduleId) {
      this.$store.dispatch('modal/openModalMelonTV', scheduleId)
    },
    showAvatar(instructor) {
      let url = null
      if (instructor && instructor.image_url) {
        url = instructor.image_url
      }
      return convertAvatar(url)
    },
    parseCssVars: parseCssVars
  }
}
</script>
